import { render, staticRenderFns } from "./addressbook.vue?vue&type=template&id=8ad98d02&scoped=true&"
import script from "./addressbook.vue?vue&type=script&lang=js&"
export * from "./addressbook.vue?vue&type=script&lang=js&"
import style0 from "./addressbook.vue?vue&type=style&index=0&id=8ad98d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad98d02",
  null
  
)

export default component.exports